<template>
  <div class="partsInventoryRecords-bd tb">
    <custom-tab :value="type" :list="tabList" class="tab" @input="onTabChange" style="margin-left: -16px; margin-right: -16px"></custom-tab>
    <template v-if="type == '1'">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 导出excel -->
          <el-form-item style="float: right; margin-right: 0">
            <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.codeName" :placeholder="$t('fms_partsInventoryRecords.pei_jian')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input v-model="formSearch.afterServiceName" clearable :placeholder="$t('fms_partsInventoryRecords.shou_hou_gong_si')" @clear="onPageChange({ page: 1 })"></el-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input v-model="formSearch.search" clearable :placeholder="$t('fms_partsInventoryRecords.ji_shen_hao')" @clear="onPageChange({ page: 1 })"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table height="100%" index :data="tableList" tableCode="partsInventory" @sort="sortChange" @filter="filterChange" @column="setColumn"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </template>
    <parts-inventory-history v-if="type == '2'"></parts-inventory-history>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partsInventoryHistory from './children/partsInventoryHistory';

export default {
  name: 'partsInventoryRecords',
  components: { partsInventoryHistory },
  data() {
    return {
      type: 1,
      formSearch: {
        codeName: '',
        afterServiceName: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
    };
  },
  computed: {
    tabList() {
      return [
        {
          name: this.$t('fms_partsInventoryRecords.pei_jian_cun_liu'),
          value: 1,
          state: this.funcView.giveaway_stock,
        },
        {
          name: this.$t('fms_partsInventoryRecords.shi_yong_li_shi'),
          value: 2,
          state: this.funcView.giveaway_record,
        },
      ].filter((t) => t.state);
    },
  },
  mounted() {

    this.getFuncView();
    this.getTableList();
  },
  methods: {
    onTabChange(value) {
      this.type = value;
    },
    getTableList() {
      this.$getJSON(apis.giveawayBalancePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    exportTable: function () {
      this.$exportFlie(apis.giveawayBalanceExport, this.formSearch).then(() => {});
    },
  },
};
</script>

<style lang="scss">
.partsInventoryRecords-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
